const False = () => false;
/**
 * provides a means for allowing framework wrappers to extend capabilities that work best with the framework
 */
const FrameworkHooks = {
    isFrameworkElement: False,
    handleExternalContent: False,
};

export { FrameworkHooks as F };

//# sourceMappingURL=frameworkHooks-5ffe86dc.js.map